var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "c-survey__wrapper",
        class: [{ "c-survey__wrapper--transition": _vm.isTransitioning }],
      },
      [
        _c("AnimationBackground"),
        _vm._v(" "),
        _c(
          "Transition",
          {
            attrs: { name: _vm.transitionName },
            on: {
              "before-enter": _vm.beforeEnter,
              "before-leave": _vm.beforeLeave,
              "after-enter": _vm.afterEnter,
              "after-leave": _vm.afterLeave,
              enter: _vm.enter,
              leave: _vm.leave,
            },
          },
          [
            _c(_vm.screenList[_vm.currentScreenIndex].component, {
              tag: "component",
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }